// Mock data for Vigyan website

export const machines = [
  {
    id: 1,
    name: "Vigyan ZB Series Automated Online Cooker Plant",
    category: "Cooker Plant",
    description: "Fully automated paddy cooking system with precise temperature control and uniform cooking quality. Features next-gen automation with AI-powered controls.",
    features: ["Fully Automated", "Uniform Cooking", "Power Saving", "Easy Operation"],
    image: "https://sales.rallyappliances.in/media/files/ZS_Steam_2.jpg"
  },
  {
    id: 2,
    name: "Vigyan-ZS Series Steam Plant",
    category: "Steam Plant",
    description: "High-efficiency steam generation system designed for paddy processing with advanced heat exchangers and energy-saving technology.",
    features: ["High Efficiency", "Stainless Steel", "Low Maintenance", "Eco-Friendly"],
    image: "https://sales.rallyappliances.in/media/files/ZS_Steam.jpg"
  },
  {
    id: 3,
    name: "Vigyan ZS Series Suction Drier",
    category: "Drier",
    description: "Advanced drying system with uniform air distribution and automated moisture control for consistent rice quality.",
    features: ["Uniform Drying", "Auto Control", "Energy Efficient", "CNC Precision"],
    image: "https://sales.rallyappliances.in/media/files/F_Plant_1.jpg"
  },
  {
    id: 4,
    name: "Vigyan-CB Series Boiled Plant",
    category: "Boiled Plant",
    description: "Complete boiling solution with tapered V-channel design for optimal paddy processing and enhanced rice quality.",
    features: ["Tapered Design", "High Performance", "SS Construction", "Easy Access"],
    image: "https://sales.rallyappliances.in/media/files/ZB_Boiled.jpg"
  },
  {
    id: 5,
    name: "Vigyan-F Series Plant",
    category: "Hot Air Furnace",
    description: "Hot air furnace dryer with advanced burner technology and precise temperature management for superior drying results.",
    features: ["Hot Air Tech", "Precise Control", "Fuel Efficient", "Durable Build"],
    image: "https://sales.rallyappliances.in/media/files/F_Plant.jpg"
  },
  {
    id: 6,
    name: "Vigyan Paddy Pre-Cleaner",
    category: "Pre-Cleaner",
    description: "Essential equipment for removing impurities like dust, straw, sand, and stones from raw paddy before milling.",
    features: ["High Capacity", "Efficient Cleaning", "Low Power", "Compact Design"],
    image: "https://sales.rallyappliances.in/media/files/Untitled_design_21.jpg"
  }
];

export const components = [
  {
    id: 1,
    name: "Storage Bunker",
    description: "Heavy-duty storage solution for paddy and rice with weather-resistant construction.",
    image: "https://images.unsplash.com/photo-1716643863806-989dd76ae093?q=85"
  },
  {
    id: 2,
    name: "Stainless Steel Bucket Elevator",
    description: "Reliable vertical transportation system manufactured with precision CNC technology.",
    image: "https://images.pexels.com/photos/34617461/pexels-photo-34617461.jpeg"
  },
  {
    id: 3,
    name: "Heat Exchanger",
    description: "High-efficiency heat transfer system for optimal energy utilization.",
    image: "https://images.unsplash.com/photo-1567093322102-6bdd32fba67d?q=85"
  },
  {
    id: 4,
    name: "Chain Conveyor",
    description: "Robust material handling system for seamless paddy transportation.",
    image: "https://images.unsplash.com/photo-1455165814004-1126a7199f9b?q=85"
  },
  {
    id: 5,
    name: "Dust Cyclone",
    description: "Efficient dust collection system maintaining clean production environment.",
    image: "https://images.unsplash.com/photo-1496247749665-49cf5b1022e9?q=85"
  },
  {
    id: 6,
    name: "Dust Bag Filters",
    description: "Advanced filtration system for air quality management in processing plants.",
    image: "https://images.unsplash.com/photo-1647427060118-4911c9821b82?q=85"
  }
];

export const services = [
  {
    id: 1,
    title: "Plant Design & Engineering",
    description: "Comprehensive layout design and engineering solutions customized to your site conditions and production requirements.",
    icon: "Drafting Compass"
  },
  {
    id: 2,
    title: "Manufacturing & Supply",
    description: "State-of-the-art CNC precision manufacturing ensuring highest quality standards and timely delivery.",
    icon: "Factory"
  },
  {
    id: 3,
    title: "Installation & Commissioning",
    description: "Professional installation services by experienced engineers ensuring optimal plant performance from day one.",
    icon: "Settings"
  },
  {
    id: 4,
    title: "After-Sales Support",
    description: "Dedicated service team providing modernization, renovation, and performance upgrades throughout plant lifecycle.",
    icon: "Headphones"
  }
];

export const technologies = [
  { name: "Artificial Intelligence", abbr: "AI" },
  { name: "Industrial Internet of Things", abbr: "IIoT" },
  { name: "Big Data Analytics", abbr: "Big Data" },
  { name: "Cloud Computing", abbr: "Cloud" },
  { name: "Smart Factory", abbr: "Smart Factory" },
  { name: "CNC Automation", abbr: "CNC" }
];

export const companyInfo = {
  name: "Vigyan",
  fullName: "Vaibhav Vigyan India Pvt. Ltd.",
  tagline: "Next-Gen Automation in Paddy Processing",
  established: "2010",
  phone: "+91 7676546036",
  email: "enquiry@vaibhavvigyan.com",
  address: "42/2, Sundar Industrial estate NTY layout, Bengaluru 560026, KA, India",
  businessHours: "Monday to Saturday 10:00 AM to 8:00 PM",
  videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
  facebook: "https://www.facebook.com/VaibhavSteel",
  instagram: "https://www.instagram.com/vaibhavigyan"
};

export const aboutContent = {
  vision: "To lead the industry in innovation and sustainability, creating high-quality products that enhance lives while minimizing environmental footprint. We empower our workforce, embrace advanced technologies, and foster partnerships that drive progress and elevate manufacturing standards.",
  mission: "Vigyan, powered by Vaibhav Steel, specializes in providing unique overall layout designs for paddy processing plants, customized machine products, and installation services. We take responsibility for engineering, supply, installation, commissioning, and after-sales service at the highest technical level, emphasizing quality, reliability, and efficiency.",
  values: [
    "Innovation & Technology Leadership",
    "Quality & Reliability",
    "Sustainability & Environmental Stewardship",
    "Customer Success & Support"
  ],
  stats: [
    { label: "Years of Experience", value: "14+" },
    { label: "Plants Installed", value: "500+" },
    { label: "Countries Served", value: "15+" },
    { label: "Customer Satisfaction", value: "98%" }
  ]
};

export const rawMaterialSuppliers = [
  { name: "SAIL", logo: "/sail.jpg" },
  { name: "Jindal Stainless", logo: "/jindal-steel.png" },
  { name: "JSW", logo: "/jsw.png" },
  { name: "Tata Steel", logo: "/tata-steel.png" }
];